const SLIDE_IN_ON_SCROLL_DURATION_MS = 400

const SLIDE_IN_ON_SCROLL_STAGGER_MS = 60

const SLIDE_IN_ON_SCROLL_KEYFRAMES: Keyframe[] = [
  { opacity: 0, translate: '0 24px' },
  { opacity: 1, translate: '0 0' },
]

const SLIDE_IN_ON_SCROLL_EASING = 'cubic-bezier(0.22, 1, 0.36, 1)'

const SLIDE_IN_ON_SCROLL_WAITING_ATTRIBUTE = 'data-slide-in-waiting'

const SLIDE_IN_ON_SCROLL_VIEWPORT_AND_ABOVE_MARGIN = '100000px 0px 0px 0px'

export {
  SLIDE_IN_ON_SCROLL_DURATION_MS,
  SLIDE_IN_ON_SCROLL_EASING,
  SLIDE_IN_ON_SCROLL_KEYFRAMES,
  SLIDE_IN_ON_SCROLL_STAGGER_MS,
  SLIDE_IN_ON_SCROLL_VIEWPORT_AND_ABOVE_MARGIN,
  SLIDE_IN_ON_SCROLL_WAITING_ATTRIBUTE,
}
